module.exports = __webpack_public_path__ + "front/img/6.b3a183b7.png";